module.exports = __webpack_public_path__ + "static/media/profile-image.5f0aae87.png";